import {
    ChangeDetectionStrategy,
    Component,
    Input,
    Self,
    OnInit,
    ChangeDetectorRef,
} from '@angular/core';
import { AbstractControl, FormControl, NgControl, ValidatorFn } from '@angular/forms';
import { filter, map, tap } from 'rxjs/operators';
import { UntilDestroy } from '@ngneat/until-destroy';
import { EntityFormControl } from '@bazis/form/models/form.types';
import { BazisFormService } from '@bazis/form/services/form.service';
import { combineLatest, merge, Observable, of, shareReplay, switchMap } from 'rxjs';
import { BazisConfigurationService, SHARE_REPLAY_SETTINGS } from '@bazis/configuration.service';
import { BazisEntityService } from '@bazis/shared/services/entity.service';
import { BazisSrvService } from '@bazis/shared/services/srv.service';
import { BazisInputHintComponent } from '@bazis/form/components/base/hint/input-hint.component';
import { BazisInputTinOrganizationComponent } from '@bazis/form/components/base/hint/input-tin-organization.component';

@UntilDestroy()
@Component({
    selector: 'app-input-tin-organization',
    templateUrl: './input-tin-organization.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class InputTinOrganizationComponent
    extends BazisInputTinOrganizationComponent
    implements OnInit
{
    selectValue(value: any) {
        const searchValue = (value.bin || value.inn) + ' ' + (value.name_ru || value.name);
        const nextValue = {
            [this.tinField]: value.bin || value.inn,
            [this.organizationField]: value.name_ru || value.name,
            searchValue,
        };

        this.valueObject = { ...nextValue };

        this.searchControl.setValue(searchValue);

        this.onChange({ ...nextValue });
        this.hideList();
    }
}
